export default __webpack_public_path__ + "static/media/benefit4.e050fc9c.svg";